import styled from "styled-components";

const LinkContainer = styled.div`
	display: flex;
	height: ${({height}) => height ? height : '200px'};
	justify-content: space-around;
	width: 100%;
	align-items: center;
`;

export default LinkContainer;